import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
// Lazy load route components
const DashboardPage = React.lazy(() => import('./pages/Dashboard'));
const ExportPage = React.lazy(() => import('./pages/Export'));
const ViewPage = React.lazy(() => import('./pages/View'));
const ParametersExpandedPage = React.lazy(() => import('./pages/ParametersExpanded'));
const HomePage = React.lazy(() => import('./pages/Home'));
function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Home route */}
          <Route path="/" element={<HomePage />} />
          
          {/* Dashboard with dynamic segments */}
          <Route 
            path="/dashboard/:urlIdentifier/:tenant_id/:orgName" 
            element={<DashboardPage />} 
          />
          
          {/* Other pages */}
          <Route path="/export" element={<ExportPage />} />
          <Route path="/view" element={<ViewPage />} />
          <Route path="/parameters-expanded" element={<ParametersExpandedPage />} />
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
